export function determineDeviceFromBody() {
    if (document.body.getAttribute("class").includes("device-")) {
        var deviceString = document.body.getAttribute("class").split("device-");
        if (deviceString[1].includes(" ")) {
            window.deviceType = deviceString[1].split(" ")[0];
        }
        else {
            window.deviceType = deviceString[1];
        }
        return true;
    }
    else {
        window.deviceType = 'couldnt be determined by useragent';
        return false;
    }
}
